import BaseCustomHelper from '../BaseCustomHelper';
import DefaultValidator from './DefaultValidator';

export default class ValidationHelper extends BaseCustomHelper {
    constructor() {
        super(process.env.CLIENT);

        this.validator = null;
        
        // set the valication mechanism for the current client
        switch (this.CLIENT) {
            default: {
                this.validator = new DefaultValidator();
                break;
            }
        }
    }

    validatePatient = (componentName, model, formError, isHighTide, isInspired) => {
        return this.validator.validatePatient(componentName, model, formError, isHighTide, isInspired);
    }

    validatePatientBirthDate = (componentName, model, formError) => {
        return this.validator.validatePatientBirthDate(componentName, model, formError);
    }
}